// extracted by mini-css-extract-plugin
export var orderDetails = "_sk-2";
export var orderImage = "_sk-1";
export var orderMeta = "_sk-3";
export var orderSummary = "_sk-0";
export var rightArrow = "_sk-4";